export default "/kiban/_next/static/images/08_2L_cupper_base_post-4724f1963f6282999227dda55c19f1bc.png";